import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconFlowsLarge({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g stroke={fill}>
                <rect x=".5" y="4.5" width="5" height="7" rx=".5"/>
                <rect x="10.5" y=".5" width="5" height="6" rx=".5"/>
                <rect x="10.5" y="9.5" width="5" height="6" rx=".5"/>
                <path d="M6 8h2V5a1 1 0 0 1 1-1h1M6 8h2v3a1 1 0 0 0 1 1h1"/>
            </g>
        </svg>
    );
}

export default IconFlowsLarge;
